/* eslint-disable flowtype/no-types-missing-file-annotation */
/* eslint-disable react/prop-types */

import React, { useRef } from "react"
import FlexView from "react-flexview/lib"
import '../buttonstyles.scss'
var classNames = require('classnames')

export default ({onClick, disabled = false, withFill, children, ...props}) => {
    const ref = useRef(null);
    const handleOnClick = () => {
        ref.current.click()
    }

    return (
        <FlexView hAlignContent={'center'} vAlignContent={'center'} 
                    onClick={handleOnClick} 
                    className={classNames({"button-disabled":disabled},
                             {"blue-button-no-fill": !disabled && !withFill},
                             {"blue-button-with-fill": !disabled && withFill})}>
                                <button {...props} onClick={(e) => onClick && onClick(e)} hidden ref={ref}></button>
            <div className="btn-text">{children}</div>
        </FlexView>
    )
}